import React, { useState } from 'react';
export function TransformationSlider() {
  const [sliderPos, setSliderPos] = useState(50);
  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSliderPos(Number(e.target.value));
  };
  return <section className="py-24 px-6 bg-white border-y-3 border-charcoal" data-id="element-187">
      <div className="max-w-7xl mx-auto" data-id="element-188">
        <div className="text-center mb-16" data-id="element-189">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-190">
            The Power of Refacing
          </h2>
          <p className="text-charcoal/60 max-w-2xl mx-auto" data-id="element-191">
            See how we transform outdated oak into modern espresso luxury in
            just 48 hours.
          </p>
        </div>

        <div className="relative aspect-[4/3] md:aspect-[21/9] w-full overflow-hidden border-3 border-charcoal select-none bg-charcoal" data-id="element-192">
          {/* Before Image (Bottom Layer) */}
          <div className="absolute inset-0" data-id="element-193">
            <img src="https://cdn.magicpatterns.com/uploads/9JPED73HDePGvhe4Sp5tSB/image.png" alt="Before Refacing" className="w-full h-full object-cover sepia-[0.5] brightness-[0.8]" data-id="element-194" />
            <div className="absolute bottom-8 left-8 bg-charcoal text-alabaster px-6 py-2 font-bold uppercase tracking-widest text-sm z-0" data-id="element-195">
              Before: Outdated Oak
            </div>
          </div>

          {/* After Image (Top Layer, Clipped) */}
          <div className="absolute inset-0 border-r-4 border-white z-10" style={{
          width: `${sliderPos}%`
        }} data-id="element-196">
            <div className="absolute inset-0 w-[100vw] md:w-[80vw] lg:w-[1280px]" data-id="element-197">
              <img src="https://images.pexels.com/photos/8186477/pexels-photo-8186477.jpeg?auto=compress&cs=tinysrgb&w=1600" alt="After Refacing" className="w-full h-full object-cover" data-id="element-198" />
            </div>
            <div className="absolute bottom-8 left-8 bg-espresso text-alabaster px-6 py-2 font-bold uppercase tracking-widest text-sm whitespace-nowrap" data-id="element-199">
              After: Espresso Reface
            </div>
          </div>

          {/* Slider Input */}
          <input type="range" min="0" max="100" value={sliderPos} onChange={handleSliderChange} className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize z-20" data-id="element-200" />

          {/* Visual Handle */}
          <div className="absolute top-0 bottom-0 w-1 bg-white z-10 pointer-events-none" style={{
          left: `${sliderPos}%`
        }} data-id="element-201">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-espresso rounded-full border-4 border-white flex items-center justify-center shadow-xl" data-id="element-202">
              <div className="flex gap-1" data-id="element-203">
                <div className="w-1 h-4 bg-white/40 rounded-full" data-id="element-204" />
                <div className="w-1 h-4 bg-white/40 rounded-full" data-id="element-205" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}